import type { CSSProperties } from "react";
import { normalizeThumbnailUrl } from "../spp/SppPluginComponent";
import {
  getOfflinePackageImageUrl,
  resolveImageUrlForDevice,
} from "../../../util/resolveOfflinePackageImageUrl";
import type { ViewerDeviceRuntime } from "../../../types";

export const LEGACY_IFRAME_LINK_OUT_ICON_HTML =
  '<svg xmlns="http://www.w3.org/2000/svg" width="45px" height="45px" viewBox="0 0 36 45" x="0px" y="0px"><path fill="#000000" d="M35,10a1,1,0,0,0,1-1V1a1,1,0,0,0-1-1H27a1,1,0,0,0,0,2h5.59L18.29,16.29a1,1,0,0,0,0,1.42,1,1,0,0,0,1.42,0L34,3.41V9A1,1,0,0,0,35,10Z"/><path fill="#000000" d="M7,36H25a7,7,0,0,0,7-7V15a1,1,0,0,0-2,0V29a5,5,0,0,1-5,5H7a5,5,0,0,1-5-5V11A5,5,0,0,1,7,6H21a1,1,0,0,0,0-2H7a7,7,0,0,0-7,7V29A7,7,0,0,0,7,36Z"/></svg>';

export function setValidIframeUrl(url: string): string {
  if (url.startsWith("//") || url.startsWith("http://") || url.startsWith("https://")) {
    return url;
  }
  return `//${url}`;
}

function readIframeThumbnailUrl(thumbnail: unknown): string | undefined {
  const normalized = normalizeThumbnailUrl(thumbnail);
  if (normalized) {
    return normalized;
  }

  if (thumbnail && typeof thumbnail === "object" && "source" in thumbnail) {
    const source = (thumbnail as { source?: { original?: { url?: unknown } } }).source;
    const url = source?.original?.url;
    if (typeof url === "string") {
      const trimmed = url.trim();
      return trimmed || undefined;
    }
  }

  return undefined;
}

export function resolveIframeMobileThumbnailUrl(
  thumbnail: unknown,
  viewerDevice?: ViewerDeviceRuntime,
): string | undefined {
  const rawUrl = readIframeThumbnailUrl(thumbnail);
  if (!rawUrl) {
    return undefined;
  }

  const resolved = resolveImageUrlForDevice(rawUrl, viewerDevice);
  if (resolved) {
    return resolved;
  }

  if (viewerDevice?.packagePath) {
    return getOfflinePackageImageUrl(viewerDevice.packagePath, rawUrl) ?? undefined;
  }

  return rawUrl;
}

export function resolveIframeContainerStyle(
  style: CSSProperties | undefined,
  isMobile: boolean,
): CSSProperties | undefined {
  if (!isMobile) {
    return style;
  }

  const {
    width: _width,
    height: _height,
    minWidth: _minWidth,
    minHeight: _minHeight,
    maxWidth: _maxWidth,
    maxHeight: _maxHeight,
    ...rest
  } = style ?? {};

  return {
    ...rest,
    width: "100%",
    maxWidth: "100%",
    minWidth: 0,
    height: "auto",
  };
}
